export default __webpack_public_path__ + "static/media/kitchen4-afterE-768w.539a6b92.png";